import request from '@/utils/axios'
// 获取任务链接
export function getImgList (data) {
  return request({
    url: '/manageApp/mobileAPI/app/push/getPushPic',
    method: 'get',
    params: data
  })
}
